<template>
    <transaction-link
        v-if="transactionLine"
        :transaction-uuid="transactionLine.transactionUuid"
        :class="{ 'text-error': transactionLine.deleted, 'text-primary': !transactionLine.deleted }"
    >
        {{ transactionLine.transactionName }}
    </transaction-link>
</template>

<script setup lang="ts">

import {TransactionLine} from '@/types/transaction/TransactionLine'
import {computed, provide} from 'vue'
import TransactionLink from '@/transaction/TransactionLink.vue'

const props = defineProps({
    params: {
        type: Object as () => {
            data: TransactionLine,
            context: any
        },
        required: true
    }
})

provide('panelId', props.params.context.panelId)
provide('panelPathSegment', props.params.context.panelPathSegment)

const transactionLine = computed(() => {
    return props.params?.data
})

</script>

<style scoped>
@reference "@/index.css";
@reference "tailwindcss";

.deleted {
    @apply text-error;
}

</style>